// Bootstrap JS and CSS
import { Collapse } from "bootstrap";
import $ from "jquery";
import FileSaver from "file-saver";
import moment from "moment";
import randomize from "randomatic";
import "./../css/main.scss";

$(function () {
  // Constants
  const inviteTitle = "Ihre sichere Videokonferenz";
  const inviteText = "Link zur sicheren Videokonferenz: ";
  const localStorageRoomsKey = "rooms20221113";
  const localStorageConsentAskedKey = "consentAsked";
  const localStorageConsentKey = "cookieConsent";
  const localStorageDonationAskedKey = "donationAsked";

  // Remove old entries from localStorage
  localStorage.removeItem("rooms");
  localStorage.removeItem("rooms20220516");

  // Restore model from localStorage if possible
  var roomsModel = localStorage.getItem(localStorageRoomsKey);
  if (roomsModel) {
    roomsModel = JSON.parse(localStorage.getItem(localStorageRoomsKey));

    // Clear old model before token to avoid errors
    if (roomsModel.length > 0 && roomsModel[0].link) {
      roomsModel = [];
      persistRoomsModel();
    }
  } else {
    roomsModel = [];
  }
  roomsModel2Html();

  // Stores roomModel in localStorage
  function persistRoomsModel() {
    // Whenever storing model, sync HTML representation with model
    roomsModel2Html();

    // Store in localStorage if allowed
    if (consentGiven()) {
      localStorage.setItem(localStorageRoomsKey, JSON.stringify(roomsModel));
    }
  }

  // Generate HTML from roomModel
  function roomsModel2Html() {
    if ($(".lp-conference-block").length === 0) return;

    // Clear all
    $(".lp-conference-block").not(".lp-template").remove();

    // Create blocks
    $.each(roomsModel, function (index, room) {
      const conferenceBlock = $(".lp-conference-block.lp-template").clone();

      conferenceBlock.removeClass("lp-template");
      conferenceBlock.find(".lp-conference-idx").val(index);
      conferenceBlock.find(".lp-conference-number").html(index + 1 + ".");
      conferenceBlock.find(".lp-conference-title").val(room.title);
      conferenceBlock
        .find(".lp-conference-link-moderator-input")
        .val(room.links.link_moderator);
      conferenceBlock
        .find(".lp-conference-link-guest-input")
        .val(room.links.link_guest);

      // Start and end time of meeting
      const startTime = moment()
        .add(moment.duration(1, "hour"))
        .set("minute", 0)
        .set("second", 0);
      conferenceBlock
        .find(".lp-conference-meeting-date-start")
        .val(startTime.format(moment.HTML5_FMT.DATETIME_LOCAL));

      const endTime = moment(startTime).add(moment.duration(30, "minute"));
      conferenceBlock
        .find(".lp-conference-meeting-date-end")
        .val(endTime.format(moment.HTML5_FMT.DATETIME_LOCAL));

      // Open last
      if (index === roomsModel.length - 1) {
        conferenceBlock.find(".lp-conference-title-toggle").data("open", true);
        conferenceBlock
          .find(".lp-conference-title-toggle img")
          .attr("src", "/img/svg/arrow-up.svg");
      } else {
        conferenceBlock.find(".lp-conference-title-toggle").data("open", false);
        conferenceBlock
          .find(".lp-conference-title-toggle img")
          .attr("src", "/img/svg/arrow-down.svg");
        conferenceBlock.find(".lp-conference-content").hide();
        conferenceBlock.find(".lp-conference-footer").hide();
      }

      $(".lp-conference").append(conferenceBlock);
    });

    // Choose button
    if (roomsModel.length > 0) {
      $(".lp-generate-first").addClass("lp-hidden");
      $(".lp-generate-more").removeClass("lp-hidden");
    } else {
      $(".lp-generate-first").removeClass("lp-hidden");
      $(".lp-generate-more").addClass("lp-hidden");
    }

    // Show share button if available
    if (typeof navigator.share === "function") {
      $(".lp-share").show();
    }

    // Adjust spacer
    $(".lp-conference-spacer").height(
      $(".lp-conference").height() - $(".lp-conference").offset().top
    );
  }

  // Creates a new room entry
  function createRoom() {
    // Generate link
    var tokenUrl = "/token/";
    if (location.hostname === "localhost") {
      tokenUrl = "/token_localhost/";
    }

    $.ajax({
      type: "GET",
      url: tokenUrl,
      dataType: "json",
      beforeSend: function (xhr) {
        xhr.setRequestHeader(
          "Authorization",
          "Basic " + btoa("script:08H3YyER7JNdx")
        );
      },
      success: function (links) {
        var titlePrefix = "Konferenz ";
        if (location.pathname.startsWith("/en")) {
          titlePrefix = "Conference ";
        }

        roomsModel.push({
          title: titlePrefix + (roomsModel.length + 1),
          links: links,
        });

        persistRoomsModel();
      },
    });
  }

  // Ask for donation in case of private users and create room
  // Do not ask for donation in case of "Kommerzielle Nutzung"
  function ask4DonationOrCreateRoom() {
    var isHome = !!$("div.lp-header-content-home").length;
    if (isHome) {
      // Ask for donation every time on this button click
      $(".lp-donation").show();

      // Aks for donation one time only
      /*
      if (!localStorage.getItem(localStorageDonationAskedKey)) {
        $(".lp-donation").show();
      } else {
        createRoom();
      }
      */
    } else {
      // Do not ask for donations in case of "Kommerzielle Nutzung" nor on the english home
      createRoom();
    }
  }

  // Click on "Neue Konferenz erstellen"
  $(".lp-conference").on("click", ".lp-generate-first", function () {
    $(this).toggleClass("lp-hidden");
    $(".lp-generate-more").toggleClass("lp-hidden");
    ask4DonationOrCreateRoom();
    _paq.push(["trackEvent", "home", "generate", "first", null]);
  });

  // Click on "weitere Konferenz erstellen"
  $(".lp-conference").on("click", ".lp-generate-more", function () {
    $(this).toggleClass("lp-hidden");
    $(".lp-generate-more").toggleClass("lp-hidden");
    ask4DonationOrCreateRoom();
    _paq.push(["trackEvent", "home", "generate", "more", null]);
  });

  // Click on "Starten" in table
  $(".lp-generate-private").on("click", function () {
    $(".lp-conference")
      .find(".lp-generate-first:visible, .lp-generate-more:visible")
      .trigger("click");
  });

  // Select all on focus to links
  $(".lp-conference").on("click", ".lp-conference-link-input", function () {
    this.setSelectionRange(0, this.value.length);
  });

  // Clicks layover "Spenden"
  $(".lp-donation").on(
    "click",
    ".lp-donation-button-yes, .lp-donation-button-no",
    function () {
      $(".lp-donation").hide();

      // Store in localStorage if allowed
      if (consentGiven()) {
        localStorage.setItem(
          localStorageDonationAskedKey,
          new Date().getTime()
        );
      }
      createRoom();
      _paq.push([
        "trackEvent",
        "donate",
        "layover",
        $(this).data("answer"),
        null,
      ]);
    }
  );

  // Focus conference title
  $(".lp-conference").on("click", ".lp-conference-title-edit", function () {
    $(this).parent().find(".lp-conference-title").trigger("focus");
  });

  // Edit conference title
  $(".lp-conference").on("change", ".lp-conference-title", function () {
    const idx = $(this).parent().parent().find(".lp-conference-idx").val();
    roomsModel[idx].title = $(this).val();
    persistRoomsModel();
  });

  // Delete conference
  $(".lp-conference").on("click", ".lp-delete", function () {
    const idx = $(this).parent().parent().find(".lp-conference-idx").val();
    roomsModel.splice(idx, 1);
    persistRoomsModel();
  });

  // Toggle conference
  $(".lp-conference").on("click", ".lp-conference-title-toggle", function () {
    if ($(this).data("open") === true) {
      $(this).find("img").attr("src", "/img/svg/arrow-down.svg");
    } else {
      $(this).find("img").attr("src", "/img/svg/arrow-up.svg");
    }

    $(this).data("open", !$(this).data("open"));
    $(this)
      .parent()
      .siblings(".lp-conference-content, .lp-conference-footer")
      .slideToggle();
  });

  // Toggle calendar function
  $(".lp-conference").on("click", ".lp-meeting-toggle", function () {
    $(this).parent().siblings(".lp-conference-meeting").slideToggle();
    // Hide button
    $(this).fadeToggle();
  });

  $(".lp-conference").on("click", ".lp-conference-meeting-close", function () {
    $(this).parents(".lp-conference-meeting").slideToggle();
    // Show button
    $(this)
      .parents(".lp-conference-block")
      .find(".lp-meeting-toggle")
      .fadeToggle();
  });

  // Click on link
  $(".lp-conference").on("click", ".lp-conference-link-link", function () {
    _paq.push(["trackEvent", "home", "go", null, null]);
  });

  // Click on "Starten"
  $(".lp-conference").on("click", ".lp-conference-start-start", function () {
    window.location.href = $(this)
      .parent()
      .parent()
      .find(".lp-conference-link-moderator-input")
      .val();
  });

  // Copy link inline
  $(".lp-conference").on("click", ".lp-conference-link-copy", function () {
    $(this).fadeOut(100).fadeIn(100);

    const link = $(this).parent().find(".lp-conference-link-input").val();
    copyLinkToClipboard(link);
    _paq.push(["trackEvent", "home", "copy", "inline", null]);
  });

  // Copy link button
  $(".lp-conference").on("click", ".lp-copy", function () {
    const link = $(this)
      .parent()
      .parent()
      .find(".lp-conference-link-link")
      .attr("href");
    copyLinkToClipboard(link);
    _paq.push(["trackEvent", "home", "copy", "button", null]);
  });

  // Share
  $(".lp-conference").on("click", ".lp-share", function () {
    const link = $(this)
      .parent()
      .parent()
      .find(".lp-conference-link-guest-input")
      .val();

    navigator
      .share({
        title: inviteTitle,
        text: inviteText,
        url: link,
      })
      .then(() => {
        _paq.push(["trackEvent", "home", "share", null, null]);
      })
      .catch(() => {
        // Error
      });
  });

  // Calendar
  $(".lp-conference").on(
    "click",
    ".lp-meeting-moderator, .lp-meeting-guest",
    function () {
      const isModerator = $(this).data("moderator");
      const parentBlock = $(this).parents(".lp-conference-block");
      const form = parentBlock.find("form");

      // Only if form is valid
      if (form[0].checkValidity()) {
        var title = parentBlock.find(".lp-conference-title").val();
        var link;
        var description;

        if (isModerator) {
          title += " (Link für Moderator)";
          link = parentBlock.find(".lp-conference-link-moderator-input").val();
          description =
            "Glückwunsch, Sie sind Moderator einer sicheren Videokonferenz!\\n\\n" +
            "Zum Starten öffnen Sie bitte folgenden Link: " +
            link +
            "\\n\\n" +
            "Die Videokonferenz startet erst, wenn Sie eintreten.\\n\\n";
        } else {
          title += " (Link für Gäste)";
          link = parentBlock.find(".lp-conference-link-guest-input").val();
          description =
            "Glückwunsch, Sie wurden zu einer sicheren Videokonferenz eingeladen!\\n\\n" +
            "Öffnen Sie einfach folgenden Link um teilzunehmen: " +
            link +
            "\\n\\n";
        }

        const start = moment(
          parentBlock.find(".lp-conference-meeting-date-start").val()
        );
        const end = moment(
          parentBlock.find(".lp-conference-meeting-date-end").val()
        );

        // Footer
        description +=
          "Hier finden Sie Antworten auf häufig gestellte Fragen: https://sichere-videokonferenz.de/faq/\\n\\n" +
          "----------------------------------------------------------------------------------------------------\\n\\n" +
          "Sichere-Videokonferenz.de - kostenlos, anonym und datenschutzkonform\\n\\n" +
          "Sichere Kommunikation sollte für jedermann möglich sein.\\n\\n" +
          "Um den Service weiterhin kostenfrei anbieten zu können, freuen wir uns natürlich über eine finanzielle Unterstützung. Diese ist freiwillig.\\n\\n" +
          "PayPal: https://www.paypal.com/paypalme/Horizon44GmbH (Geld senden)\\n\\n" +
          "Gerne stellen wir Ihnen bei Bedarf eine Rechnung inkl. MwSt. aus.";

        const ics =
          "BEGIN:VCALENDAR" +
          "\r\nVERSION:2.0" +
          "\r\nPRODID:https://sichere-videokonferenz.de/" +
          "\r\nCALSCALE:GREGORIAN" +
          "\r\nBEGIN:VEVENT" +
          "\r\nUID:" +
          moment().unix() +
          "@sichere-videokonferenz.de" +
          "\r\nDTSTAMP:" +
          moment().format("YYYYMMDDTHHmmss") +
          "\r\nSUMMARY:" +
          title +
          "\r\nDTSTART:" +
          start.format("YYYYMMDDTHHmmss") +
          "\r\nDTEND:" +
          end.format("YYYYMMDDTHHmmss") +
          "\r\nLOCATION:" +
          link +
          "\r\nDESCRIPTION:" +
          description +
          "\r\nEND:VEVENT" +
          "\r\nEND:VCALENDAR";

        var blob = new Blob([ics], { type: "text/calendar;charset=utf-8" });
        FileSaver.saveAs(blob, "sichere-videokonferenz-de.ics");

        _paq.push(["trackEvent", "home", "calendar", isModerator, null]);
      }
    }
  );

  function storeConsentOrNot(consent) {
    const now = new Date().getTime();
    localStorage.setItem(localStorageConsentAskedKey, now);
    localStorage.setItem(localStorageConsentKey, consent);

    // Delete stored rooms
    if (!consent) {
      localStorage.removeItem(localStorageRoomsKey);
    }

    $(".lp-cookie-consent").hide();
    $(".lp-cookie-consent-bg").hide();
  }

  function consentGiven() {
    return (
      localStorage.getItem(localStorageConsentAskedKey) !== null &&
      localStorage.getItem(localStorageConsentKey) === "true"
    );
  }

  // Click on burger
  $(".lp-burger").on("click", "a", function () {
    $(".lp-nav-top").fadeToggle();

    if ($(".lp-burger img").attr("src") === "/img/svg/burger.svg") {
      $(".lp-burger img").attr("src", "/img/svg/burger-close.svg");
    } else {
      $(".lp-burger img").attr("src", "/img/svg/burger.svg");
    }
  });

  // Consent dialog
  $(".lp-cookie-consent").on(
    "click",
    ".lp-cookie-consent-button-ok",
    function () {
      _paq.push(["rememberConsentGiven"]);
      storeConsentOrNot(true);
    }
  );

  $(".lp-cookie-consent").on(
    "click",
    ".lp-cookie-consent-button-not-ok",
    function () {
      _paq.push(["forgetConsentGiven"]);
      storeConsentOrNot(false);
    }
  );

  // Consent buttons in Datenschutzerklärung
  if (consentGiven()) {
    $(".lp-cookie-consent-remove").show();

    $(".lp-cookie-consent-remove").on(
      "click",
      ".lp-cookie-consent-remove-button",
      function () {
        _paq.push(["forgetConsentGiven"]);
        storeConsentOrNot(false);
        window.location.reload();
      }
    );
  } else {
    $(".lp-cookie-consent-give").show();

    $(".lp-cookie-consent-give").on(
      "click",
      ".lp-cookie-consent-give-button",
      function () {
        _paq.push(["rememberConsentGiven"]);
        storeConsentOrNot(true);
        window.location.reload();
      }
    );
  }

  // Feedback dialog
  const referrer = document.referrer;
  //const referrer = 'https://sichere-videokonferenz.de/VxTxynSXouauk';
  if (referrer.startsWith(baseLink) && /[A-Za-z0-9]{13}$/.test(referrer)) {
    $(".lp-feedback").show();
    $(".lp-feedback-bg").show();
    _paq.push(["trackEvent", "home", "feedback", "open", null]);

    // Click on star
    $(".lp-feedback").on("click", ".lp-rating-star", function (e) {
      const rating = parseInt($(this).data("rating"));

      // Mark
      $(".lp-rating-star img")
        .attr("src", "/img/svg/rating-star.svg")
        .slice(0, rating)
        .attr("src", "/img/svg/rating-star-filled.svg");

      // Execute function
      if (rating < 4) {
        // Open feedback email, wait for star to fill
        window.setTimeout(function () {
          window.location.href = generateMailtoLink(
            supportEmail,
            "Mein Feedback zur Nutzung von " + hostname + " (" + rating + "*)",
            "Bitte helfen Sie uns, die Anwendung weiter zu verbessern. Welche Probleme hatten sie während der Konferenz?"
          );
        }, 300);
      } else {
        // Show sharing
        $(".lp-feedback-share").show();
      }

      _paq.push(["trackEvent", "home", "feedback", "rating", rating]);
    });

    // Share if available
    if (typeof navigator.share === "function") {
      $(".lp-feedback-share-share")
        .show()
        .on("click", function () {
          navigator
            .share({
              title: inviteTitle,
              text: "Ich hatte gerade ein ausgezeichnetes Videokonferenz-Erlebnis! Einfach und kostenlos ausprobieren, ganz ohne Anmeldung: ",
              url: baseLink,
            })
            .then(() => {
              _paq.push(["trackEvent", "home", "feedback", "share", "social"]);
            })
            .catch(() => {
              // Error
            });
        });
    }

    // Email
    $(".lp-feedback").on("click", ".lp-feedback-share-email", function () {
      window.location.href = generateMailtoLink(
        "",
        "Mein ausgezeichnetes Erlebnis mit " + baseLink,
        "Liebe/r ,\nich habe gerade an einer Videokonferenz teilgenommen. Diese ist DSGVO konform, anonym, kostenlos und das Beste ist, es bedarf keiner Anmeldung.\n\nAnbei der Link: " +
          baseLink +
          "\n\nBeste Grüße"
      );
      _paq.push(["trackEvent", "home", "feedback", "share", "email"]);
    });

    // Close
    $(".lp-feedback").on("click", ".lp-feedback-button-close", function () {
      $(".lp-feedback").hide();
      $(".lp-feedback-bg").hide();
      _paq.push(["trackEvent", "home", "feedback", "close", null]);
    });
  }

  // FAQ
  $(".lp-faq").on("click", "ol a", function () {
    jumpToQuestion($(this).attr("href"));
  });

  // Deep link to question
  if (
    document.location.hash != null &&
    document.location.hash.startsWith("#faq_")
  ) {
    jumpToQuestion(document.location.hash);
  }

  // Jump to question
  function jumpToQuestion(hash) {
    $("html, body").animate({
      scrollTop: $(hash).prev().offset().top,
    });

    // Open answer
    new Collapse($(hash)).show();
  }

  function randomRoom() {
    return randomize("Aa0", 13);
  }

  function copyLinkToClipboard(val) {
    const el = document.createElement("textarea");
    el.value = val;
    document.body.appendChild(el);
    el.select();
    document.execCommand("copy");
    document.body.removeChild(el);
  }

  function generateMailtoLink(to, subject, body) {
    const args = [];
    if (typeof subject !== "undefined") {
      args.push("subject=" + encodeURIComponent(subject));
    }
    if (typeof body !== "undefined") {
      args.push("body=" + encodeURIComponent(body));
    }

    var url = "mailto:" + encodeURIComponent(to);
    if (args.length > 0) {
      url += "?" + args.join("&");
    }
    return url;
  }
});
